import { FileSignature } from 'lucide-react';

export function ClientContractsEmptyState() {
  return (
    <div className="rounded-md border bg-white py-16 text-center">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
        <FileSignature className="h-6 w-6 text-gray-400" />
      </div>
      <p className="text-sm text-muted-foreground">
        Ainda não há contratos por cliente cadastrados.
      </p>
    </div>
  );
}
